import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

// Authentication
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

// Components
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import InstanceView from './components/InstanceView';
import Navigation from './components/Navigation';
import Profile from './components/Profile';
import UserManagement from './components/UserManagement';
import Monitoring from './components/Monitoring';
import ReportingView from './components/ReportingView';
import VIXView from './components/VIXView';
import FedTradeView from './components/FedTradeView';
import MarketTickerBar from './components/MarketTickerBar';

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box sx={{ display: 'flex' }}>
    <Navigation />
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        p: { xs: 2, sm: 3 },
        mt: { xs: 7, md: 0 },
        width: { xs: '100%', md: 'calc(100% - 260px)' },
      }}
    >
      <MarketTickerBar />
      {children}
    </Box>
  </Box>
);

// Create theme
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route path="/" element={<ProtectedRoute><AppLayout><Dashboard /></AppLayout></ProtectedRoute>} />
            <Route path="/instance/:name" element={<ProtectedRoute><AppLayout><InstanceView /></AppLayout></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><AppLayout><Profile /></AppLayout></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute requireAdmin={true}><AppLayout><UserManagement /></AppLayout></ProtectedRoute>} />
            <Route path="/monitoring" element={<ProtectedRoute requireAdmin={true}><AppLayout><Monitoring /></AppLayout></ProtectedRoute>} />
            <Route path="/reporting" element={<ProtectedRoute requireAdmin={true}><AppLayout><ReportingView /></AppLayout></ProtectedRoute>} />
            <Route path="/vix" element={<ProtectedRoute requireAdmin={true}><AppLayout><VIXView /></AppLayout></ProtectedRoute>} />
            <Route path="/fedtrade" element={<ProtectedRoute requireAdmin={true}><AppLayout><FedTradeView /></AppLayout></ProtectedRoute>} />

            {/* Redirect unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App; 